import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { VehicleInsuranceCoverageTypeEnum } from '../enums/vehicle-insurance-coverage-type.enum';
import { VehicleInsuranceRecordCategoryEnum } from '../enums/vehicle-insurance-record-category.enum';
import { VehicleInsuranceStatusEnum } from '../enums/vehicle-insurance-status.enum';

/**
 * Vehicle insurances filters
 */
export class VehicleInsurancesFilters extends ApiRequestFilters {
	/**
	 * Check-out from date
	 */
	@TransformDate()
	startsAtFrom?: Date;

	/**
	 * Check-out to date
	 */
	@TransformDate()
	startsAtTo?: Date;

	/**
	 * Check-out from date
	 */
	@TransformDate()
	endsAtFrom?: Date;

	/**
	 * Check-out to date
	 */
	@TransformDate()
	endsAtTo?: Date;

	/**
	 * Individual dates that are contained within the StartsAt and EndsAt period
	 */
	@TransformDate()
	containsDates?: Date[];

	/**
	 * Premium amount from
	 */
	@TransformFloat()
	amountFrom?: number;

	/**
	 * Premium amount to
	 */
	@TransformFloat()
	amountTo?: number;

	/**
	 * Excess amount from
	 */
	@TransformFloat()
	excessAmountFrom?: number;

	/**
	 * Excess amount to
	 */
	@TransformFloat()
	excessAmountTo?: number;

	/**
	 * Insured value from
	 */
	@TransformFloat()
	insuredValueFrom?: number;

	/**
	 * Insured value to
	 */
	@TransformFloat()
	insuredValueTo?: number;

	/**
	 * Vehicles id values
	 */
	vehicles?: number[];

	/**
	 * Suppliers id values
	 */
	suppliers?: number[];

	/**
	 * Status values
	 */
	statuses?: VehicleInsuranceStatusEnum[];

	/**
	 * Record category enum values
	 */
	recordCategories?: VehicleInsuranceRecordCategoryEnum[];

	/**
	 * Record category enum values
	 */
	coverageTypes?: VehicleInsuranceCoverageTypeEnum[];

	/**
	 * Vehicle category id values
	 */
	vehicleCategories?: number[];

	/**
	 * Tag id values
	 */
	tags?: number[];
}
